import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0978b774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-dropdown w-100 h-100" }
const _hoisted_2 = { class: "dropdown d-flex h-100 align-items-center" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  ref: "dropdownMenu",
  class: "dropdown-menu opacity-100 w-100"
}
const _hoisted_5 = {
  id: "accordionSearchBox",
  class: "accordion accordion-flush"
}
const _hoisted_6 = { class: "accordion-item" }
const _hoisted_7 = ["id"]
const _hoisted_8 = ["data-bs-target"]
const _hoisted_9 = ["id", "aria-labelledby"]
const _hoisted_10 = { class: "accordion-body ps-30 f-14" }
const _hoisted_11 = ["data-value"]
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox_btn = _resolveComponent("checkbox-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        id: "dropdown-toggle",
        ref: "dropdownToggle",
        class: _normalizeClass(["btn btn-block btn-search-box f-16 text-start text-truncate fw-medium dropdown-toggle", _ctx.ltmsBtnClasses]),
        type: "button",
        "data-bs-toggle": "dropdown",
        "data-bs-auto-close": "outside",
        "data-bs-offset": "0,0",
        "aria-expanded": "false",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click',$event))),
        innerHTML: _ctx.selectedLabel
      }, null, 10 /* CLASS, PROPS */, _hoisted_3),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, idx) => {
            return (_openBlock(), _createElementBlock("ul", {
              key: `${group.id}_${idx}`,
              class: "list-unstyled"
            }, [
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("p", {
                  id: `heading_${group.url}`,
                  class: "accordion-header"
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["accordion-button px-25 f-14", _ctx.isGroupIdSelected(group.id)? 'fw-semibold' :'collapsed']),
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#collapse_${group.url}`,
                    "aria-expanded": "true",
                    "aria-controls": "collapseOne"
                  }, _toDisplayString(_ctx.decodeTextWithEntities(group.label)), 11 /* TEXT, CLASS, PROPS */, _hoisted_8)
                ], 8 /* PROPS */, _hoisted_7),
                _createElementVNode("div", {
                  id: `collapse_${group.url}`,
                  class: _normalizeClass(["accordion-collapse collapse", _ctx.isGroupIdSelected(group.id)?'show':'']),
                  "aria-labelledby": `heading_${group.url}`,
                  "data-bs-parent": "#accordionSearchBox"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listingTypologies.filter(o => o.group === group.label), (listingTypology) => {
                      return (_openBlock(), _createBlock(_component_checkbox_btn, {
                        id: 'checkbox_' + listingTypology.id,
                        key: listingTypology.id,
                        class: "d-flex align-items-center",
                        "data-id": 'checkbox_' + listingTypology.id,
                        label: listingTypology.label,
                        "container-id": `listing-typology-row-${listingTypology.listingTypologyId}`,
                        "label-class": "w-100",
                        checked: _ctx.isSelected(listingTypology),
                        onChange: ($event: any) => {_ctx.manageListingTypology(_ctx.listingTypologies,listingTypology);}
                      }, null, 8 /* PROPS */, ["id", "data-id", "label", "container-id", "checked", "onChange"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_9)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listingTypologies.filter(lt => !lt.group), (listingTypology) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `${_ctx.name}_menu_${listingTypology.id}`,
            "data-element": "",
            "data-value": listingTypology.id,
            class: _normalizeClass(["ps-25 accordion-button pointer", _ctx.isSelected(listingTypology)?'active bg-w-cultured fw-semibold':''])
          }, [
            (_openBlock(), _createBlock(_component_checkbox_btn, {
              id: 'checkbox_' + listingTypology.id,
              key: listingTypology.id,
              class: "d-flex align-items-center ps-0 py-15 w-100",
              "container-id": `listing-typology-row-${listingTypology.listingTypologyId}`,
              checked: _ctx.isSelected(listingTypology),
              "input-class": "d-none",
              "wrapper-margin-y": "my-0",
              onChange: ($event: any) => {_ctx.manageListingTypology(_ctx.listingTypologies,listingTypology);}
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", {
                  class: "w-100 f-14",
                  innerHTML: listingTypology.label
                }, null, 8 /* PROPS */, _hoisted_12)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "container-id", "checked", "onChange"]))
          ], 10 /* CLASS, PROPS */, _hoisted_11))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */)
    ])
  ]))
}